// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"81":"83adde400da84b60","191":"8f09cfdf981419a4","557":"3c4100abe509a663","895":"49ded51690105cb7"}[chunkId] + ".js";
};